import { useWindowSize } from "hooks/useWindowSize";
import { useDeviceSize } from "hooks";
import { PressLogosContent } from "modules/common/components/PressLogos";
import { ChakraImage as Image, ChakraBox as Box, ChakraFlex as Flex } from "@airhelp/react-ui-components";

interface PressImageProps {
  srcDesktop: string;
  srcMobile?: string;
  alt: string;
}

export const PressImage = ({ srcDesktop, srcMobile, alt }: PressImageProps) => {
  const windowSize = useWindowSize();
  const { isMobile } = useDeviceSize();

  if (!windowSize) return null;

  const { isTablet } = windowSize;

  const src = (isTablet ? srcMobile : srcDesktop) || srcDesktop;

  return (
    <Box pos="relative" mx={{ base: 4, md: 0 }} height={{ base: "400px", md: "unset" }}>
      <Image
        src={src}
        alt={alt}
        loading="lazy"
        m="auto"
        width="100%"
        height="100%"
        borderRadius={isMobile && "2xl"}
        objectFit="cover"
        filter="brightness(0.8)"
      />
      <Flex position="absolute" bottom={{ base: 5, lg: "12%" }} align="center" direction="column" width="100%">
        <PressLogosContent textColor="greyscale.100" logoColor="white" fontWeight="bold" />
      </Flex>
    </Box>
  );
};
